import React from "react";
import { MapPin } from "lucide-react";
import { useCatalog } from "../../contexts/CatalogContext";

const cardClass = (status) =>
  status === "live"
    ? "border-[#22C55E] bg-green-50 text-slate-900"
    : "border-slate-200 bg-slate-50 text-slate-500";

const pillClass = (status) =>
  status === "live" ? "bg-[#22C55E] text-white" : "bg-slate-200 text-slate-600";

export default function CoverageSection() {
  const { CITIES } = useCatalog();

  return (
    <section className="bg-white border-y border-slate-200" data-testid="coverage-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-10">
          <span className="text-xs font-semibold text-[#0369A1] uppercase tracking-widest">Coverage</span>
          <h2 className="font-display font-bold text-3xl sm:text-4xl text-slate-900 mt-2">Where we service</h2>
        </div>
        <div className="flex flex-wrap justify-center gap-4">
          {CITIES.map((c) => (
            <div
              key={c.id}
              data-testid={`coverage-${c.id}`}
              className={`px-6 py-4 rounded-xl border-2 flex items-center gap-3 ${cardClass(c.status)}`}
            >
              <MapPin className={`w-5 h-5 ${c.status === "live" ? "text-[#22C55E]" : "text-slate-400"}`} />
              <span className="font-display font-bold">{c.name}</span>
              <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${pillClass(c.status)}`}>
                {c.status === "live" ? "Live" : "Coming soon"}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
